import handleKey from '../../internal/utils/handle-key';
const KEYBOARD_SINGLE_STEP_SIZE = 10;
const KEYBOARD_MULTIPLE_STEPS_SIZE = 60;
const getCurrentSize = (panelRef) => {
    if (!panelRef || !panelRef.current) {
        return {
            panelHeight: 0,
            panelWidth: 0,
        };
    }
    return {
        panelHeight: panelRef.current.clientHeight,
        panelWidth: panelRef.current.clientWidth,
    };
};
export const useKeyboardEvents = ({ position, onResize, panelRef }) => {
    return {
        onDirectionClick: (direction) => {
            let currentSize;
            const { panelHeight, panelWidth } = getCurrentSize(panelRef);
            if (['side', 'side-start'].includes(position)) {
                currentSize = panelWidth;
            }
            else {
                currentSize = panelHeight;
            }
            const singleStepUp = () => onResize(currentSize + KEYBOARD_SINGLE_STEP_SIZE);
            const singleStepDown = () => onResize(currentSize - KEYBOARD_SINGLE_STEP_SIZE);
            switch (direction) {
                case 'block-start':
                case 'inline-start':
                    position === 'side-start' ? singleStepDown() : singleStepUp();
                    break;
                case 'block-end':
                case 'inline-end':
                    position === 'side-start' ? singleStepUp() : singleStepDown();
                    break;
            }
        },
        onKeyDown: (event) => {
            let currentSize;
            let maxSize;
            const { panelHeight, panelWidth } = getCurrentSize(panelRef);
            if (['side', 'side-start'].includes(position)) {
                currentSize = panelWidth;
                // don't need the exact max size as it's constrained in the set size function
                maxSize = window.innerWidth;
            }
            else {
                currentSize = panelHeight;
                // don't need the exact max size as it's constrained in the set size function
                maxSize = window.innerHeight;
            }
            let isEventHandled = true;
            const singleStepUp = () => onResize(currentSize + KEYBOARD_SINGLE_STEP_SIZE);
            const singleStepDown = () => onResize(currentSize - KEYBOARD_SINGLE_STEP_SIZE);
            const multipleStepUp = () => onResize(currentSize + KEYBOARD_MULTIPLE_STEPS_SIZE);
            const multipleStepDown = () => onResize(currentSize - KEYBOARD_MULTIPLE_STEPS_SIZE);
            handleKey(event, {
                onBlockStart: () => {
                    ['bottom', 'side-start'].includes(position) ? singleStepUp() : singleStepDown();
                },
                onBlockEnd: () => {
                    ['bottom', 'side-start'].includes(position) ? singleStepDown() : singleStepUp();
                },
                onInlineEnd: () => {
                    ['bottom', 'side-start'].includes(position) ? singleStepUp() : singleStepDown();
                },
                onInlineStart: () => {
                    ['bottom', 'side-start'].includes(position) ? singleStepDown() : singleStepUp();
                },
                onPageDown: () => multipleStepDown(),
                onPageUp: () => multipleStepUp(),
                onHome: () => onResize(maxSize),
                onEnd: () => onResize(0),
                onDefault: () => (isEventHandled = false),
            });
            if (isEventHandled) {
                event.preventDefault();
            }
        },
    };
};
//# sourceMappingURL=use-keyboard-events.js.map